import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormChipInput from "../../input/ReactHookFormChipInput";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionReferrerDomain(props) {
    const {control, setValue, getValues} = props;

    const rules = useWatch({control, name: "rules"}) || {};
    const referrerDomainData = rules?.referrerDomain;
    const hasReferrerDomainCondition = !!referrerDomainData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.referrerDomain;
        setValue("rules", currentRules);
    };

    const addCondition = () => {
        setValue("rules.referrerDomain", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasReferrerDomainCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>Referrer domain</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasReferrerDomainCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            Referrer domain
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.referrerDomain.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.referrerDomain.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <ReactHookFormChipInput
                            control={control}
                            name="rules.referrerDomain.values"
                            label="Referrer domain"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionReferrerDomain;
